import MUIDialogActions from '@mui/material/DialogActions';

export const DialogActions = MUIDialogActions;
